import React, { useState } from 'react';
import { withTranslation } from 'react-i18next';
import { makeStyles } from '@mui/styles';
import { useTheme } from '@mui/material/styles';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import MenuItem from '@mui/material/MenuItem';
import ListItem from '@mui/material/ListItem';
import Menu from '@mui/material/Menu';
import AccountCircle from '@mui/icons-material/AccountCircle';
import { clearSession } from '../helpers/helper.js';
import ProjectSelect from './ProjectSelect.jsx';
import packageJson from '../../package.json';
import { Typography } from '@mui/material';

const useStyles = makeStyles((theme) => ({
    marginTop: theme.mixins.toolbar,
    grow: {
        flexGrow: 1,
    },
    title: {
        display: 'none',
        [theme.breakpoints.up('sm')]: {
            display: 'block',
        },
    },
    inputRoot: {
        color: 'inherit',
    },
    inputInput: {
        padding: theme.spacing(1, 1, 1, 0),
        // vertical padding + font size from searchIcon
        paddingLeft: `calc(1em + ${theme.spacing(4)}px)`,
        transition: theme.transitions.create('width'),
        width: '100%',
        [theme.breakpoints.up('md')]: {
            width: '20ch',
        },
    },
}));

function TopAppBar(props) {
    const [setPosition] = useState(null);
    const [setLightPoints] = useState(null);
    const [anchorEl, setAnchorEl] = useState(null);

    const theme = useTheme()
    const classes = useStyles(theme);

    const isMenuOpen = Boolean(anchorEl);

    const handleProfileMenuOpen = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleMenuClose = () => {
        setAnchorEl(null);
    };

    const handleProfileClick = () => {
        handleMenuClose();
        props.onProfileClick();
    };

    const handleLogout = () => {
        handleMenuClose();
        // Funzione di Logout eutente
            clearSession()
            setTimeout(() => {
                props.updateLoginState({ "loggedInStatus": "NOT_LOGGED_IN", "user": null, "cabinets": null, "projectId": null, });
            }, 0);
    }

    /**
     * Gestione del centro mappa
     * La funzione viene passata come proprietà all'oggetto SelectProject
     */
    const handleUpdateMap = (geometry, zoom, reslightPoints) => {
        setPosition({ "lat": geometry.lat, "lng": geometry.lng });
        setLightPoints(reslightPoints);
    }

    const menuId = 'primary-search-account-menu';
    const renderMenu = (
        <Menu
            anchorEl={anchorEl}
            anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
            id={menuId}
            keepMounted
            transformOrigin={{ vertical: 'top', horizontal: 'right' }}
            open={isMenuOpen}
            onClose={handleMenuClose}
        >
            <MenuItem onClick={handleProfileClick}>{props.t("profile")}</MenuItem>
            <MenuItem onClick={handleLogout} divider>{props.t("exit")}</MenuItem>
            <ListItem>
                <Typography variant="subtitle2">v.{packageJson.version}</Typography>
            </ListItem>
        </Menu>
    );

    return (
        <div className={classes.grow}>
            <AppBar position="fixed">
                <Toolbar>
                    <IconButton
                        size="large"
                        edge="start"
                        color="inherit"
                        aria-label="menu"
                        onClick={props.onDrawerClick}>
                        <MenuIcon />
                    </IconButton>
                    <div className={classes.grow} />
                    <ProjectSelect
                        updateMapPosition={handleUpdateMap}
                        projects={props.projects}
                        defaultProjectId={props.projectId}
                        onChangeProject={props.onChangeProject}
                    />
                    <div className={classes.grow} />
                    <IconButton
                        size="large"
                        edge="end"
                        aria-label="account of current user"
                        aria-controls={menuId}
                        aria-haspopup="true"
                        onClick={handleProfileMenuOpen}
                        color="inherit">
                        <AccountCircle />
                    </IconButton>
                </Toolbar>
            </AppBar>
            {renderMenu}
        </div>
    );
}

export default withTranslation()(TopAppBar);
